"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_transition_group_1 = require("react-transition-group");
const base_ui_components_atoms_button_1 = require("@motorata/base-ui.components.atoms.button");
const Modal_1 = require("./Modal");
const EmptyModal = ({ children, show, setShow, modalBackgroundId = "root-modal-background", modalContentId = "root-modal-content", }) => {
    let childrenElement;
    if (children) {
        if (Array.isArray(children)) {
            childrenElement = [];
            children.map(el => childrenElement.push(react_1.default.cloneElement(el, { setShow: setShow })));
        }
        else {
            childrenElement = react_1.default.cloneElement(children, { setShow: setShow });
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_1.Portal, { id: modalBackgroundId },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: show, timeout: 200, classNames: "background", unmountOnExit: true },
                react_1.default.createElement(exports.Background, { onClick: setShow ? () => setShow(false) : () => { } }))),
        react_1.default.createElement(Modal_1.Portal, { id: modalContentId },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: show, timeout: 200, classNames: "content", unmountOnExit: true },
                react_1.default.createElement(Wrapper, { className: `hide_scroll`, onClick: setShow ? () => setShow(false) : () => { } },
                    react_1.default.createElement(Content, null, childrenElement),
                    react_1.default.createElement(CloseWrapper, null,
                        react_1.default.createElement(base_ui_components_atoms_button_1.IconButton, { icon: "close", color: "second", onClick: () => setShow(false) })))))));
};
exports.default = EmptyModal;
const CloseWrapper = styled_components_1.default.div `
  position: absolute;
  right: ${({ theme }) => theme.space.S};
  top: ${({ theme }) => theme.space.S};
`;
const Content = styled_components_1.default.div `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const Wrapper = styled_components_1.default.div `
  width: 100vw;
  height: 100vh;
  opacity: 1;
  z-index: 100;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  left: 0;
  top: 0;
  padding: ${({ theme }) => theme.space.S};
  
  &.content-enter {
    opacity: 0;
  }

  &.content-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }

  &.content-exit {
    opacity: 1;
  }

  &.content-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }
`;
exports.Background = styled_components_1.default.div `
  background: rgba(0, 0, 0, 0.8);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 99;

  &.background-enter {
    opacity: 0;
  }

  &.background-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }

  &.background-exit {
    opacity: 1;
  }

  &.background-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }
`;
//# sourceMappingURL=EmptyModal.js.map